import { colors } from '@factorialco/deprecated-design-system'
import { CustomLayerProps, Point, Serie } from '@nivo/line'

import { findHoveredPoints, isStartOrEndPoint } from './helpers'

const CustomVerticalLineLayer = (hoveredPoint: Point | null, series: Serie[]) => {
  const Component = ({}: CustomLayerProps) => {
    if (
      !hoveredPoint ||
      isStartOrEndPoint(hoveredPoint) ||
      !findHoveredPoints(hoveredPoint, series).length
    )
      return null

    return (
      <line
        y1={0}
        y2={250}
        strokeWidth={1}
        x1={hoveredPoint.x}
        x2={hoveredPoint.x}
        stroke={colors.grey600}
      />
    )
  }

  return Component
}

export { CustomVerticalLineLayer }
